import React from 'react'
import AEMFooter from './GlobalFooter'
import { useAemHeaderFooterQuery } from '@src/queries/AemQuery.generated'

const WrappedFooter = () => {
  const { data } = useAemHeaderFooterQuery()

  if (!data?.aemHeaderFooter?.footer) return null

  return <AEMFooter {...data.aemHeaderFooter.footer} />
}

export default WrappedFooter
